import { render, staticRenderFns } from "./DropFiles.vue?vue&type=template&id=78fa2d3a&scoped=true&"
import script from "./DropFiles.vue?vue&type=script&lang=js&"
export * from "./DropFiles.vue?vue&type=script&lang=js&"
import style0 from "./DropFiles.css?vue&type=style&index=0&id=78fa2d3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa2d3a",
  null
  
)

export default component.exports